// Badge icon imports
import badge1 from '@/assets/icons/badges/m1-kindess-keeper.webp'
import badge2 from '@/assets/icons/badges/m2-footprint-forecaster.webp'
import badge3 from '@/assets/icons/badges/m3-safe-lock-star.webp'
import badge4 from '@/assets/icons/badges/m4-privacy-protector.webp'
import badge5 from '@/assets/icons/badges/m5-scam-stopper.webp'
import badge6 from '@/assets/icons/badges/m6-red-flag-ranger.webp'
import badge7 from '@/assets/icons/badges/m7-bug-blocker.webp'
import badge8 from '@/assets/icons/badges/m8-true-identity-inspector.webp'
import badge9 from '@/assets/icons/badges/m9-boundary-builder.webp'
import badge10 from '@/assets/icons/badges/m10-social-engineering-sleuth.webp'
import badge11 from '@/assets/icons/badges/m11-courage-captain.webp'
import badge12 from '@/assets/icons/badges/m12-truth-tracker.webp'

export const missionBadges = {
  1: {
    badgeType: 'mission',
    badgeId: 'mission_1',
    badgeName: 'Kindness Keeper',
    smallDescription: 'Mastered spotting and stopping harmful online behaviors',
    badgeDescription:
      'You became a Kindness Keeper by learning how to recognize cyberbullying and respond with confidence and empathy. You now know how to stand up for yourself or others and when to step away, block, or report harmful behavior. This reward represents your mastery of standing up to cyberbullying with confidence and empathy.',
    notificationText:
      '[ChildName] became a Kindness Keeper by learning how to recognize cyberbullying and respond with confidence and empathy. They now know how to stand up for themselves or others and when to step away, block, or report harmful behavior. 💜',
    badgeIcon: badge1,
    missionId: 1,
    missionTitle: 'Cyberbullying',
    keyWords: [
      'cyberbullying',
      'empathy',
      'confidence',
      'respect',
      'digital kindness',
      'standing up for others'
    ],
    rewardVideoUrl:
      'gs://digipalz-10512.firebasestorage.app/video/rewards/kindness-keeper.mp4'
  },
  2: {
    badgeType: 'mission',
    badgeId: 'mission_2',
    badgeName: 'Footprint Finder',
    smallDescription: 'Learning how digital actions track and shape reputation',
    badgeDescription:
      'You earned the Footprint Forecaster reward by learning how posts, messages, and images leave permanent digital footprints. You can now pause before sharing and understand how online choices can affect school, friendships, and future opportunities. This reward recognizes your understanding of how every online action leaves a digital footprint.',
    notificationText:
      '[ChildName] earned the Footprint Forecaster reward by learning how posts, messages, and images leave permanent digital footprints. They can now pause before sharing and understand how online choices can affect school, friendships, and future opportunities. 👣',
    badgeIcon: badge2,
    missionId: 2,
    missionTitle: 'IP Addresses & Digital Footprints',
    keyWords: [
      'digital footprints',
      'online actions',
      'future impact',
      'awareness',
      'long-term consequences'
    ],
    rewardVideoUrl:
      'gs://digipalz-10512.firebasestorage.app/video/rewards/footprint-finder-2.mp4'
  },
  3: {
    badgeType: 'mission',
    badgeId: 'mission_3',
    badgeName: 'Safe Lock Star',
    smallDescription:
      'Practice strong password habits and multi-factor authentication',
    badgeDescription:
      'You earned the Safe Lock Star reward by learning how to create strong passwords and protect your devices. You now know how to prevent account break-ins, data theft, and unauthorized access to personal information. This reward celebrates your mastery of strong passwords and safe device habits.',
    notificationText:
      '[ChildName] earned the Safe Lock Star by learning how to create strong passwords and protect their devices. They now know how to prevent account break-ins, data theft, and unauthorized access to personal information. 🔐',
    badgeIcon: badge3,
    missionId: 3,
    missionTitle: 'Passwords & Device Safety',
    keyWords: [
      'strong passwords',
      'account security',
      'device safety',
      'privacy protection',
      'digital identity'
    ],
    rewardVideoUrl:
      'gs://digipalz-10512.firebasestorage.app/video/rewards/kindness-keeper.mp4'
  },
  4: {
    badgeType: 'mission',
    badgeId: 'mission_4',
    badgeName: 'Privacy Protector',
    smallDescription: 'Explore safe sharing and protecting privacy boundaries',
    badgeDescription:
      "You became a Privacy Protector by learning what personal information should never be shared online. You can now recognize oversharing and protect details like location, school, photos, and contact information. This reward represents your understanding of what to keep private, what's safe to share, and how to protect your personal world online.",
    notificationText:
      '[ChildName] became a Privacy Protector by learning what personal information should never be shared online. They can now recognize oversharing and protect details like location, school, photos, and contact information. ️',
    badgeIcon: badge4,
    missionId: 4,
    missionTitle: 'Personal & Private Information',

    keyWords: [
      'personal information',
      'privacy choices',
      'safe sharing',
      'online boundaries',
      'data protection'
    ],
    rewardVideoUrl:
      'gs://digipalz-10512.firebasestorage.app/video/rewards/mission4.webm'
  },
  5: {
    badgeType: 'mission',
    badgeId: 'mission_5',
    badgeName: 'Scam Stopper',
    smallDescription: 'Investigate scams and protect personal data from fraud',
    badgeDescription:
      'You earned the Scam Stopper reward by learning how phishing and scams work. You can now identify suspicious messages, fake prizes, and urgent requests designed to steal personal or family information. This reward recognizes your ability to spot phishing attempts and protect your personal information.',
    notificationText:
      '[ChildName] earned the Scam Stopper reward by learning how phishing and scams work. They can now identify suspicious messages, fake prizes, and urgent requests designed to steal personal or family information. 🚫',
    badgeIcon: badge5,
    missionId: 5,
    missionTitle: 'Identity Theft & Phishing',
    keyWords: [
      'phishing',
      'scams',
      'fraud awareness',
      'personal information safety',
      'online threats'
    ]
  },
  6: {
    badgeType: 'mission',
    badgeId: 'mission_6',
    badgeName: 'Red Flag Ranger',
    smallDescription: 'Detect fake prizes, jobs, and charity scams',
    badgeDescription:
      'You became a Red Flag Ranger by learning how to spot warning signs in messages, profiles, and offers. You can now recognize when something feels "off" and avoid engaging with risky or misleading interactions. This reward celebrates your ability to recognize scams and misleading offers online.',
    notificationText:
      '[ChildName] became a Red Flag Ranger by learning how to spot warning signs in messages, profiles, and offers. They can now recognize when something feels "off" and avoid engaging with risky or misleading interactions. 🚩',
    badgeIcon: badge6,
    missionId: 6,
    missionTitle: 'Online Scams',
    keyWords: [
      'warning signs',
      'misleading offers',
      'scam detection',
      'critical awareness',
      'smart decision-making'
    ]
  },
  7: {
    badgeType: 'mission',
    badgeId: 'mission_7',
    badgeName: 'Bug Blocker',
    smallDescription: 'Identify viruses, worms, and ransomware prevention',
    badgeDescription:
      'You earned the Bug Blocker reward by learning how malware spreads through links and downloads. You now know how to avoid clicking unsafe content that could damage devices or expose private data. This reward recognizes your understanding of how malware works and how to avoid unsafe links or downloads.',
    notificationText:
      '[ChildName] earned the Bug Blocker reward by learning how malware spreads through links and downloads. They now know how to avoid clicking unsafe content that could damage devices or expose private data. 🐞',
    badgeIcon: badge7,
    missionId: 7,
    missionTitle: 'Malware',
    keyWords: [
      'malware',
      'unsafe links',
      'downloads',
      'device protection',
      'cyber security basics'
    ]
  },
  8: {
    badgeType: 'mission',
    badgeId: 'mission_8',
    badgeName: 'True Identity Inspector',
    smallDescription: 'Spot red flags in fake accounts and online interactions',
    badgeDescription:
      "You became a True Identity Inspector by learning how fake profiles and impersonation work. You can now identify when someone online is pretending to be someone they're not and avoid unsafe conversations. This reward celebrates your ability to spot fake profiles and stay alert when talking to people online.",
    notificationText:
      "[ChildName] became a True Identity Inspector by learning how fake profiles and impersonation work. They can now identify when someone online is pretending to be someone they're not and avoid unsafe conversations. 🕵️‍♂️",
    badgeIcon: badge8,
    missionId: 8,
    missionTitle: 'Catfishing & Fake Profiles',
    keyWords: [
      'fake profiles',
      'online impersonation',
      'indentitiy verification',
      'stranger danger',
      'online awareness'
    ]
  },
  9: {
    badgeType: 'mission',
    badgeId: 'mission_9',
    badgeName: 'Boundary Builder',
    smallDescription: 'Recognize grooming tactics and follow Stop-Save-Tell',
    badgeDescription:
      'You earned the Boundary Builder reward by learning how to set and enforce digital boundaries. You now know how to say no, stop conversations, and disengage when interactions become uncomfortable or inappropriate. This reward recognizes your ability to set strong digital boundaries, recognize unsafe behavior, and protect yourself.',
    notificationText:
      '[ChildName] earned the Boundary Builder reward by learning how to set and enforce digital boundaries. They now know how to say no, stop conversations, and disengage when interactions become uncomfortable or inappropriate. ❤️',
    badgeIcon: badge9,
    missionId: 9,
    missionTitle: 'Grooming & Online Predators',
    keyWords: [
      'digital boundaries',
      'consent',
      'unsafe behavior',
      'self-protection',
      'empowerment'
    ]
  },
  10: {
    badgeType: 'mission',
    badgeId: 'mission_10',
    badgeName: 'Social Engineering Sleuth',
    smallDescription: 'Learn how hackers use tricks and how to resist them',
    badgeDescription:
      'You became a Social Engineering Sleuth by learning how scammers manipulate trust, urgency, and emotions. You can now recognize when someone is trying to pressure or trick you into sharing information or taking risky actions. This reward celebrates your ability to pause, question, and verify before trusting messages or requests online.',
    notificationText:
      '[ChildName] became a Social Engineering Sleuth by learning how scammers manipulate trust, urgency, and emotions. They can now recognize when someone is trying to pressure or trick them into sharing information or taking risky actions. 📸',
    badgeIcon: badge10,
    missionId: 10,
    missionTitle: 'Social Engineering',
    keyWords: [
      'verification',
      'skepticism',
      'message evaluation',
      'critical thinking',
      'online trust'
    ]
  },
  11: {
    badgeType: 'mission',
    badgeId: 'mission_11',
    badgeName: 'Courage Captain',
    smallDescription: 'Identify threats and support peers facing pressure',
    badgeDescription:
      'You earned the Courage Captain reward by learning how extortion and sextortion work and what to do if someone threatens, pressures, or blackmails you online. You now know not to comply, how to preserve evidence, and who to tell immediately to get help and stop the situation safely. This reward recognizes your ability to stay safe during pressure, intimidation, or unsafe online requests.',
    notificationText:
      '[ChildName] earned the Courage Captain reward by learning how extortion and sextortion work and what to do if someone threatens, pressures, or blackmails them online. They now know not to comply, how to preserve evidence, and who to tell immediately to get help and stop the situation safely. 🛟',
    badgeIcon: badge11,
    missionId: 11,
    missionTitle: 'Extortion',
    keyWords: [
      'pressure resistance',
      'intimidation awareness',
      'seeking help',
      'confidence',
      'safety reporting'
    ]
  },
  12: {
    badgeType: 'mission',
    badgeId: 'mission_12',
    badgeName: 'Truth Tracker',
    smallDescription: 'Understand AI and spot deepfake clues',
    badgeDescription:
      'You became a Truth Tracker by learning how AI, deepfakes, and altered media can be used to deceive. You can now question suspicious images or videos and avoid believing or sharing manipulated content. This reward celebrates your understanding of how AI, deepfakes, and altered media can trick people.',
    notificationText:
      '[ChildName] became a Truth Tracker by learning how AI, deepfakes, and altered media can be used to deceive. They can now question suspicious images or videos and avoid believing or sharing manipulated content. 🤖',
    badgeIcon: badge12,
    missionId: 12,
    missionTitle: 'Artificial Intelligence & Deepfakes',
    keyWords: [
      'AI literacy',
      'deepfakes',
      'misinformation',
      'media manipulation',
      'critical thinking'
    ]
  }
}

export const quizBadges = {
  // Quiz badges can be added here in the future
}

export const gameBadges = {
  // Game badges can be added here in the future
}

export const getBadgeByMissionId = (missionId) => {
  return missionBadges[missionId] || null
}

export const getBadgeDefinition = (badgeType, activityId) => {
  if (badgeType === 'mission') {
    return getBadgeByMissionId(activityId)
  } else if (badgeType === 'quiz') {
    return quizBadges[activityId] || null
  } else if (badgeType === 'game') {
    return gameBadges[activityId] || null
  }
  return null
}

export const getAllMissionBadges = () => {
  return Object.values(missionBadges)
}
